import AppointmentListModelBase from '../_generated/modelBases/appointment-list-model-base';

export default class AppointmentListModel extends AppointmentListModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
